import React from "react";
import { FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";

const LegalPage = ({ eyebrow = "Legal", title, intro = [], sections }) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-hero">
        <div className="legal-hero-inner">
          <Link className="legal-back" to="/">
            <FiArrowLeft aria-hidden="true" />
            Back to home
          </Link>
          <p>{eyebrow}</p>
          <h1>{title}</h1>
        </div>
      </header>

      <article className="legal-content">
        {intro.length > 0 && (
          <div className="legal-intro">
            {intro.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        )}

        <div className="legal-sections">
          {sections.map((section, index) => (
            <section key={section.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <div>
                <h2>{section.title}</h2>
                {section.paragraphs.map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex}>{paragraph}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default LegalPage;
